import { Types } from "../actions/PlannedMaintenanceListActions";

const initialState = {
    tasklist: null,
    taskListMultiple: null,
    poolList: null,
    poolListByAssignedUser: null,
    statusList: null,
    plannedMaintainanceList: null,
    technicianList: null,
    costCenterList: null,
    mainListByAreaId: null,
    subListByAreaId: null,
    areaList: null,
    maintenanceTypeList: null,
    error: null,

    isTaskUpdated: false,
};

export const PlannedMaintenanceListReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                tasklist: action.payload || state.tasklist,
            };

        case Types.SET_PLANNED_MAINTENANCE_MULTIPLE:
            return {
                ...state,
                taskListMultiple: action.payload || state.taskListMultiple,
            };

        case Types.SET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                poolList: action.payload.resultObject,
            };

        case Types.SET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                poolList: null,
                statusList: action.payload.resultObject,
            };

        case Types.SET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                areaList: action.payload.resultObject,
            };

        case Types.SET_PLANNED_MAINTATENANCE_LIST:
            return {
                ...state,
                plannedMaintainanceList: action.payload,
            };

        case Types.SET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                technicianList: action.payload,
            };

        case Types.SET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST: {
            return {
                ...state,
                costCenterList: action.payload.resultObject,
            };
        }

        case Types.SET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                mainListByAreaId: action.payload.resultObject,
            };

        case Types.SET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                subListByAreaId: action.payload.resultObject,
            };
        case Types.SET_MAINTENANCE_TYPE_LIST:
            return {
                ...state,
                maintenanceTypeList: action.payload.resultObject,
            };

        case Types.SET_POOL_LIST_BY_ASSIGNED_USER:
            return {
                ...state,
                poolListByAssignedUser: action.payload.resultObject,
            };


        // ------------------------- reset state ------------------------

        case Types.RESET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                tasklist: null,
            };

        case Types.RESET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                poolList: null,
            };

        case Types.RESET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                statusList: null,
            };

        case Types.RESET_PLANNED_MAINTATENANCE_LIST:
            return {
                ...state,
                plannedMaintainanceList: null,
            };

        case Types.RESET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                technicianList: null,
            };

        case Types.RESET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                costCenterList: null,
            };

        case Types.RESET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                areaList: null,
            };

        case Types.RESET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                mainListByAreaId: null,
            };

        case Types.RESET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST:
            return {
                ...state,
                subListByAreaId: null,
            };
        case Types.IS_UPDATED_TASK_PLANNED:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };

        default:
            return state;
    }
};
